import { Switch } from "antd";
import { useEffect, useState } from "react";
import "./toggle.scss";

function Toggle({ value, active, onChange, label = null, isSmall }) {
  const [isChecked, setIsChecked] = useState(active);

  useEffect(() => {
    setIsChecked(active);
  }, [active]);

  const handleChange = (checked) => {
    setIsChecked(checked);
    if (onChange) {
      onChange(checked);
    }
  };

  return (
    <div className="flex align-center gap-2 toggle-comp">
      <Switch
        size={isSmall ? "small" : undefined}
        id={label}
        value={value}
        onChange={handleChange}
        checked={isChecked}
      />
      {label && (
        <label className="toggle-label" htmlFor={label}>
          {label}
        </label>
      )}
    </div>
  );
}

export default Toggle;
